import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from '@common-packages/routes-definitions';

import AppkitIcon from '../../../../shared/displayComponents/appkitIcon/appkitIcon.component';

import styles from './federalDataDetails.module.scss';

const ReturnToFederalDataDiagnostics = () => {
  return (
    <Link to={Routes.federalDataDiagnostics.MAIN}>
      <span className={styles.backText}>
        <AppkitIcon icon="left-chevron" size={14} /> TO DIAGNOSTICS
      </span>
    </Link>
  );
};

export default ReturnToFederalDataDiagnostics;
